module.exports = __webpack_public_path__ + "img/KE.5d45eaae.svg";